angular.module 'zc.masterApi'

.factory "MasterMongoSession", ($q, FacadeV2) ->


  class MasterMongoSession

    @find: (query, options = {}) ->
      $q (resolve, reject) ->
        query ||= {}
        unless query._id or
              (query.apikey and query.opened_at) or
              (query.apikey and options.sort and options.sort.indexOf("opened_at") >= 0)
          return reject "no _id or apikey/opened_at provided"

        FacadeV2.request "/master/sessions",
          params:
            match: query
            sort: options.sort
            limit: options.limit || 1000
        .then (res) ->
          if res.status != 200 || res.data.error
            return reject res.data.error
          resolve res.data

  MasterMongoSession



// WEBPACK FOOTER //
// ./src/master_admin_modules/master_api/facade/master_mongo_session.service.coffee